<div class="main-delete position-relative">
    <img class="close-icon" src="assets/svg/close-icon.svg" alt="close svg" (click)="cancel()">

  <div class="text-part">
    <span class="text-part-title">{{ 'confirmation_popup.title' | translate }}</span>
    <span class="text-part-info">
     {{ 'confirmation_popup.description' | translate }}
    </span>
  </div>

  <div class="action-part">
    <button class="option-cancel option-shared" (click)="cancel()">{{ 'confirmation_popup.cancel' | translate }}</button>
    <button class="option-delete option-shared" (click)="submitSelection()">{{ 'confirmation_popup.connect' | translate }}</button>
  </div>
</div>
